import { FC } from 'react';
import styled from 'styled-components';

import { PageHeader, PageHeaderProps } from 'ui/pageHeader';
import { spacing } from 'ui/theme';

export type SubHeaderProps = {
  actions?: PageHeaderProps['pageActions'];
};

const StyledPageHeader = styled(PageHeader)`
  margin-top: 0;
`;

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const SubHeaderActions: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <StyledWrapper data-test="sub-header-actions">{children}</StyledWrapper>;
};

export const SubHeader: FC<React.PropsWithChildren<SubHeaderProps>> = ({ actions, children }) => (
  <StyledPageHeader data-test="sub-header" pageActions={actions}>
    {children}
  </StyledPageHeader>
);
